<template>
  <div class="original-exam">
    <template>
      <!-- 教科書選択 -->
      <v-section-panel useBreak>
        <template v-slot:title> 準拠 <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-textbooks/>
        </template>
      </v-section-panel>

      <!-- 学年選択 -->
      <v-section-panel useBreak>
        <template v-slot:title> 学年 <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-grades/>
        </template>
      </v-section-panel>

      <!-- 教科選択 -->
      <v-section-panel useBreak>
        <template v-slot:title> 種別 <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-categories :listType="listType"/>
        </template>
      </v-section-panel>

        <!-- 応用問題を選択した場合、種別の選択を表示  -->
        <v-question-type-select-options useBreak class="" v-if="ouyouSelected"/>

      <!-- 和英選択 -->
      <v-section-panel useBreak v-if="reibunSelected">
        <template v-slot:title> 英/和選択（※複数選択可）<font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-eiwa />
        </template>
      </v-section-panel>

      <!-- 出題対象、品詞の追加 -->
      <v-question-target-pos useBreak v-if="reibunSelected"/>

      <!-- 英和、和英いずれか選択済の場合、範囲・問題数選択を表示  -->
      <v-question-range-options useBreak v-if="categorySelected"/>

    </template>
  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceGrades from '@/components/molecules/ChoiceGrades'
import VChoiceTextbooks from '@/components/molecules/ChoiceTextbooks'
import VChoiceCategories from '@/components/molecules/ChoiceCategories'
import VChoiceEiwa from '@/components/molecules/ChoiceEiwa'
import VQuestionTypeSelectOptions from '@/components/organizms/QuestionTypeSelectOptions'
import VQuestionTargetPos from '@/components/organizms/QuestionTargetPos'
import VQuestionRangeOptions from '@/components/organizms/QuestionRangeOptions'

export default {
  components: {
    VSectionPanel,
    VChoiceGrades,
    VChoiceTextbooks,
    VQuestionTypeSelectOptions,
    VChoiceCategories,
    VChoiceEiwa,
    VQuestionTargetPos,
    VQuestionRangeOptions,
  },

  data: () => ({
    listType: 'kyokasho',
  }),

  computed: {
    categorySelected() {
      let result = false
      if(this.$store.state.conditions.selectedCategory > 0) {
        if(this.$store.state.conditions.selectedCategory === 2) {
          //応用問題の場合は、例文・活用のいずれかにチェックがついている場合のみtrue
          if((this.$store.state.conditions.checkedArr['reibun'].length > 0 && this.$store.state.conditions.checkedArr['target'].length!==0 && this.$store.state.conditions.checkedArr['eiwa'].length!==0)
            || this.$store.state.conditions.checkedArr['katsuyo'].length > 0) {
            result = true
          }
        } else {
          //見出し・テーマ別の場合(単語・連語が選択済みの場合のみtrue)
          if(this.$store.state.conditions.checkedArr['target'].length===0 || this.$store.state.conditions.checkedArr['eiwa'].length===0) result = false
          else result = true
        }
      }
      return result
    },
    reibunSelected() {
      let result = false
      if(this.$store.state.conditions.selectedCategory > 0) {
        if(this.$store.state.conditions.selectedCategory === 2) {
          //応用問題の場合は、例文・活用・反意語のいずれかにチェックがついている場合のみtrue
          if(this.$store.state.conditions.checkedArr['reibun'].length > 0) {
            result = true
          }
        } else {
          //見出し・テーマ別の場合はtrue
          result = true
        }
      }
      return result
    },
    ouyouSelected() {
      return this.$store.state.conditions.selectedCategory === 2
    },
    waeiSelected() {
      return this.$store.state.conditions.selectedWaeiCategory != ''
    }
  },

  methods: {
    questionCreate() {
    }
  }
}
</script>

<style lang="stylus" scoped>
.choice-material__attention
  color #747474
</style>
